import React from 'react';
import type { ReactNode } from 'react';
import { buildContext } from '@tectonics/utils/context';
import type { CountrySchema, FieldFeature } from './types';

const { Context, useContext: useCountrySchema } = buildContext<CountrySchema>('CountrySchemaContext');

interface CountrySchemaProviderProps {
  readonly countrySchema: CountrySchema;
  readonly children: ReactNode;
}

function CountrySchemaProvider({
  countrySchema,
  children,
}: CountrySchemaProviderProps): JSX.Element {
  return (
    <Context.Provider value={countrySchema}>
      {children}
    </Context.Provider>
  );
}

function useField(fieldId: string): FieldFeature {
  const countrySchema = useCountrySchema();

  const field = countrySchema.fields.find(f => f.id === fieldId);

  if (!field) {
    throw new Error(`Field with id "${fieldId}" not found in country schema`);
  }
  return field;
}

export { CountrySchemaProvider, useCountrySchema, useField };
